// extracted by mini-css-extract-plugin
export default {"Loader":"PageSpinner_Loader__5NMHh","load6":"PageSpinner_load6__BRrd-","round":"PageSpinner_round__KGKI9"};